import brand from '@helpers/brand';
import styled, { css } from 'styled-components';

const Image = styled.svg<{ w: number; h: number; includeBorder: boolean }>`
  ${({ w, h }) => css`
    width: ${w}px;
    height: ${h}px;
  `};

  ${({ includeBorder }) =>
    includeBorder
      ? css`
          use {
            stroke: ${brand.white};
            stroke-width: 10;
          }
        `
      : null};
`;

export const CultureFlagStyles = {
  Image,
};
